import React from "react";
import { useGlobalContext } from "./context/globalContext";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/logo.png"
          height="65px"
          loading="lazy"
          alt="Ajmera Vikhroli"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Raymond Realty is a renowned real estate developer committed to
        redefining urban living with premium residential projects that offer
        superior design, modern amenities, and exceptional connectivity. With a
        legacy of trust and excellence, Raymond Realty delivers developments
        that focus on quality, innovation, and customer satisfaction.
        <br /> Raymonds Mahim is set to become another landmark project,
        offering exquisite living spaces designed for those who seek nothing but
        the best.
      </p>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
